import React from 'react'
import cx from 'classnames'

import Image from 'components/ui/Image/Image'

import s from './ImageContainer.scss'


const ImageContainer = ({ className, src, w, gender, min, forceMinImage }) => {
  return (
    <Image src={src} w={w}>
      {
        (image, _src, postfix) => (
          <div
            className={cx(s.wrapper, className, {
              [s[gender]]: !src && gender,
              [s.min]: min,
            })}
          >
            {
              Boolean(src && !/^data:image/.test(src)) && (
                <div
                  className={s.imageContainer}
                  data-image-src={!w ? src : image}
                  data-image-min={w && !forceMinImage ? _src + `&w=10` : null}
                  data-blur="true"
                  style={forceMinImage ? {
                    backgroundImage: `url(${!w ? src : _src + `&w=10`})`,
                  } : null}
                />
              )
            }
            {
              /^data:image/.test(src) && (
                <div
                  className={s.imageContainer}
                  style={{ backgroundImage: `url(${!w ? src : _src + `&w=10`})` }}
                />
              )
            }
          </div>
        )
      }
    </Image>
  )
}


export default ImageContainer
